import { render, staticRenderFns } from "./TextMessage.vue?vue&type=template&id=258ead36&scoped=true"
import script from "./TextMessage.vue?vue&type=script&lang=js"
export * from "./TextMessage.vue?vue&type=script&lang=js"
import style0 from "./TextMessage.vue?vue&type=style&index=0&id=258ead36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ead36",
  null
  
)

export default component.exports